<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine></BaseTopLine>

    <div class="tw-bg-[#33497B] tw-px-[26px] tw-flex tw-justify-between">
      <div class="vue-tabs-type-1 vue-tabs">
        <div class="nav-tabs-navigation">
          <div class="nav-tabs-wrapper">
            <ul role="tablist" class="nav nav-tabs px-0">
              <li
                class="tab"
                @click="handleTabChange('Активные')"
                :class="{
                  active: activateTab == 'Активные',
                }"
              >
                <a
                  href="#"
                  role="tab"
                  class="tabs__link"
                  :class="{
                    active_tab: activateTab == 'Активные',
                  }"
                >
                  Активные
                </a>
              </li>
              <li
                class="tab"
                @click="handleTabChange('Архивные')"
                :class="{
                  active: activateTab == 'Архивные',
                }"
              >
                <a
                  href="#"
                  :class="{
                    active_tab: activateTab == 'Архивные',
                  }"
                  class="tabs__link"
                >
                  Архивные
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="tw-flex tw-items-center tw-gap-[15px]"
        v-if="activateTab == 'Активные'"
        style=""
      >
        <div class="tw-text-[11px] text-white">Оповещать о новых заявках</div>
        <div class="tw-flex tw-items-center tw-gap-[15px]">
          <BaseCheckboxV2
            placeholder=""
            class="gap-5"
            boxClass="bg-white"
            input-name="sound"
            v-model="userPageSetting.sound"
            @oncheckeds="updateUserSettingCheckboxValue"
          >
            <span class="text-white">Звук</span>
          </BaseCheckboxV2>
          <BaseCheckboxV2
            placeholder=""
            class="gap-5"
            boxClass="bg-white"
            input-name="sms"
            v-model="userPageSetting.sms"
            @oncheckeds="updateUserSettingCheckboxValue"
          >
            <span class="text-white">SMS</span>
          </BaseCheckboxV2>
          <BaseCheckboxV2
            placeholder=""
            class="gap-5"
            boxClass="bg-white"
            input-name="email"
            v-model="userPageSetting.email"
            @oncheckeds="updateUserSettingCheckboxValue"
          >
            <span class="text-white">E-mail</span>
          </BaseCheckboxV2>
        </div>
      </div>
    </div>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-mt-[15px]"
      ref="topFilter"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[430px]"
      >
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">№ Заявки</label>
          <BaseInputNew
            class="tw-w-[200px]"
            @keyupEnter="loadData()"
            inputClass="tw-app-input-dark"
            placeholder=""
            @input="fillFilter"
            :additionalParams="{}"
            inputName="b2b_orders__id"
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label"> Дата заявки </label>
          <div class="tw-flex tw-gap-[10px] tw-items-center">
            <BaseDatePicker
              class="tw-bg-white !tw-text-white tw-bg-opacity-[15%] tw-rounded-[3px] [&_i]:!tw-text-white tw-w-full"
              input-class="tw-app-input-dark !tw-bg-transparent"
              v-model="filterTimes.ordersCreateStart"
              type="date"
              placeholder="c"
              lang="ru"
              value-type="format"
              :format="`${userSetting.company__tempalte_date}`"
              @change="(date) => setCreatedAtFilter('from', date)"
              :disabled-date="disabledFutureDates"
            >
            </BaseDatePicker>
            -
            <BaseDatePicker
              class="tw-bg-white !tw-text-white tw-bg-opacity-[15%] tw-rounded-[3px] [&_i]:!tw-text-white tw-w-full"
              input-class="tw-app-input-dark !tw-bg-transparent"
              v-model="filterTimes.ordersCreateEnd"
              type="date"
              placeholder="по"
              lang="ru"
              value-type="format"
              :format="`${userSetting.company__tempalte_date}`"
              @change="(date) => setCreatedAtFilter('to', date)"
              :disabled-date="
                (date) =>
                  disabledPastDates(
                    filterTimes.ordersCreateStart
                      ?.split('.')
                      ?.reverse()
                      ?.join('-'),
                    date
                  )
              "
            >
            </BaseDatePicker>
          </div>
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">ID покупателя</label>
          <BaseInputNew
            class="tw-w-[200px]"
            @keyupEnter="loadData()"
            inputClass="tw-app-input-dark"
            placeholder=""
            @input="fillFilter"
            :additionalParams="{}"
            inputName="b2b_orders__buyer_company_id"
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">ID поставщика</label>
          <BaseInputNew
            class="tw-w-[200px]"
            @keyupEnter="loadData()"
            inputClass="tw-app-input-dark"
            placeholder=""
            @input="fillFilter"
            :additionalParams="{}"
            inputName="b2b_orders__supplier_company_id"
          />
        </div>

        <div class="tw-flex tw-flex-row">
          <button type="button" class="tw-app-btn-primary" @click="loadData()">
            Найти
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetFilter">
            Сбросить
          </button>
        </div>
      </div>
    </div>

    <div class="tw-px-[26px] tw-mt-[15px]">
      <div class="tw-mb-[15px] tw-flex tw-items-center tw-gap-[10px]">
        <button
          class="tw-app-btn-primary"
          @click="$modal.show('createOrderSupplyModal')"
        >
          <img
            :src="require(`@/assets/icons/addwhite.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          Добавить
        </button>
        <button
          class="tw-app-btn-primary-outline"
          @click="
            () =>
              activeSelectRowsMultiple.length
                ? $modal.show('deleteModal')
                : $toast.error('Выберите хотя-бы одно поле')
          "
        >
          <img
            :src="require(`@/assets/icons/minus-dark.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          Удалить
        </button>
      </div>
    </div>

    <!-- разделитель -->

    <div>
      <div class="tw-px-[26px]" style="min-height: 250px">
        <div v-show="!localLoading">
          <div class="tw-flex tw-justify-between">
            <div class="tw-flex">
              <button @click="loadData()" class="tw-app-btn-primary-outline">
                {{ dataLang["register_btn_filter_on"] }}
              </button>
              <button
                @click="resetFilter()"
                class="tw-app-btn-light !tw-text-[#0056AF]"
              >
                Сбросить
              </button>
            </div>
            <TwBasePagination
              :page-count="numPages"
              :pagination-params="{
                ...paginationFinesStateParams,
                limit: limitPaginationValue,
              }"
              :showLimitInput="true"
              @updateLimitValue="updateLimitValue"
              :page-range="10"
              :margin-pages="0"
              :click-handler="loadData"
            >
            </TwBasePagination>
          </div>

          <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
            <BaseLoader v-if="localLoading"></BaseLoader>
            <ve-table
              class="rest-style-table fixed-header"
              style="width: 100%"
              :columns="columns"
              :table-data="dataTable"
              :border-x="true"
              :border-y="true"
              row-key-field-name="b2b_orders__id"
              ref="mainTable"
              :eventCustomOption="eventCustomOption"
              :cell-style-option="cellStyleOption"
              :checkbox-option="{
                selectedRowChange: selectedRowChange,
                selectedAllChange: selectedAllChange,
                hideSelectAll: false,
              }"
              :clickHighlight="false"
              :rowStyleOption="{
                hoverHighlight: true,
              }"
              :cellSelectionOption="{ enable: false }"
            >
            </ve-table>
          </div>
        </div>
      </div>
    </div>

    <BaseModal
      name="deleteModal"
      width="420"
      height="320"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('deleteModal')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">Точно удалить?</div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('deleteModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="onAcceptDelete"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Выполнить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="createOrderSupplyModal"
      @before-close="
        () => {
          selectsCreateModal = {
            b2b_orders__b2b_product_id: null,
            b2b_orders__buyer_company_id: null,
            b2b_orders__city_id: null,
          };
        }
      "
      width="486"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('createOrderSupplyModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">Создание новой заявки</div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Город</div>
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              :showNoOptions="false"
              :showNoResults="false"
              selectLabel=""
              deselectLabel=""
              v-model="selectsCreateModal.b2b_orders__city_id"
              label="name"
              :options="selectsDataForCreateModal.b2b_orders__city_id"
              :maxHeight="160"
            >
            </BaseSelect>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Товар, услуга</div>
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              :showNoOptions="false"
              :showNoResults="false"
              selectLabel=""
              deselectLabel=""
              v-model="selectsCreateModal.b2b_orders__b2b_product_id"
              label="name"
              :options="selectsDataForCreateModal.b2b_orders__b2b_product_id"
              :maxHeight="160"
            >
            </BaseSelect>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">ID заказчика (ЛС)</div>
            <BaseSelect
              class="multiselect-type-3"
              placeholder=""
              :showNoOptions="false"
              :showNoResults="false"
              selectLabel=""
              deselectLabel=""
              v-model="selectsCreateModal.b2b_orders__buyer_company_id"
              label="label"
              :options="selectsDataForCreateModal.b2b_orders__buyer_company_id"
              :maxHeight="84"
            >
            </BaseSelect>
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('createOrderSupplyModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="onSaveModalCreate"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <SuperSuppliersModal @updateDataTable="resetFilter" />
  </div>
</template>

<style lang="scss">
.cell-status-suppliers-new {
  background-color: #ff3a20 !important;
}

.cell-status-suppliers-work {
  background-color: #f5b704 !important;
}

.cell-status-suppliers-control {
  background-color: #44d2ff !important;
}

.cell-status-suppliers-edit {
  background-color: #23b14d !important;
}
</style>

<script>
import { globalMixin } from "@/mixins/global";
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import SuperSuppliersModal from "@/views/super-suppliers-modal/SuperSuppliersModal.vue";

export default {
  mixins: [globalMixin],
  components: {
    VeTable,
    SuperSuppliersModal,
  },

  data() {
    return {
      limitPaginationValue: 50,
      filterTimes: {
        ordersCreateStart: "",
        ordersCreateEnd: "",
      },
      searchInnString: "",
      searchInnState: null,
      newPromoString: "",
      errorAddPromoData: null,
      typePin: "",
      fullSum: 0,
      callbackForSum: () => {},
      summForPayment: 0,
      summForPaymentWithPercent: 0,
      foundsList: {},
      localLoading: true,
      statisticsFromMainRequest: {},
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      activateTab: "",
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      intervalUpdate: null,
      haveNewOrder: false,
      activePagePagination: {},
      pincode: "",
      totalOnType: 0,
      dataForModal: {},
      aboutPageInfo: null,
      dataOfErrors: null,
      senderSmsPreset: null,
      peremText: "",
      typeOpenCancel: "",
      codeFromSms: "",
      selectsDataForCreateModal: {
        b2b_orders__b2b_product_id: [],
        b2b_orders__buyer_company_id: [],
        b2b_orders__city_id: [],
      },
      selectsCreateModal: {
        b2b_orders__b2b_product_id: null,
        b2b_orders__buyer_company_id: null,
        b2b_orders__city_id: null,
      },
      userPageSetting: {
        sound: false,
        sms: false,
        email: false,
      },
      selectsDataForModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsFromModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsData: {
        b2b_orders__status_id: [],
        b2b_orders__b2b_product_id: [],
        b2b_orders__city_id: [],
      },
      selectsFilter: {
        b2b_orders__status_id: [],
        b2b_orders__b2b_product_id: [],
        b2b_orders__city_id: [],
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              console.log("CLICK EVENT FROM TABLE", row);
              this.$modal.show("superSuppliersModal", {
                b2b_orders__id: row.b2b_orders__id,
                isArchive: this.activateTab === "Архивные",
              });
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field === "status") {
            if (row.status === "Новый") {
              return "cell-status-suppliers-new";
            } else if (row.status === "В работе") {
              return "cell-status-suppliers-work";
            } else if (row.status === "Фин.контроль") {
              return "cell-status-suppliers-control";
            } else if (row.status === "Период правок") {
              return "cell-status-suppliers-edit";
            } else {
              return "";
            }
          }
        },
      },
    };
  },

  methods: {
    onSaveModalCreate() {
      if (
        this.selectsCreateModal.b2b_orders__b2b_product_id &&
        this.selectsCreateModal.b2b_orders__buyer_company_id &&
        this.selectsCreateModal.b2b_orders__city_id
      ) {
        GeneralService.editOrCreate(`/b2b-orders/type2`, {
          b2b_orders__b2b_product_id:
            this.selectsCreateModal.b2b_orders__b2b_product_id.id,
          b2b_orders__buyer_company_id:
            this.selectsCreateModal.b2b_orders__buyer_company_id.value,
          b2b_orders__city_id: this.selectsCreateModal.b2b_orders__city_id.id,
        })
          .then((data) => {
            this.$toast.success(data.data.message);
          })
          .catch((e) => {
            if (e?.response) {
              this.$toast.error(e?.response.data.message, { duration: 5000 });
            }
          })
          .finally(() => {
            this.$modal.hide("createOrderSupplyModal");
            this.loadData();
          });
      }
    },
    onAcceptCancelModal() {
      GeneralService.edit(
        `/b2b-orders/${this.activeSelectRowsMultiple.at(-1)}`,
        { b2b_orders__status_id: 6 }
      )
        .then((data) => {
          this.$toast.success(data.data.message);
        })
        .catch((e) => {
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          }
        })
        .finally(() => {
          this.activeSelectRowsMultiple = [];
          this.$modal.hide("lastCancelSupplierModal");
          this.loadData();
        });
    },
    updateUserSettingCheckboxValue(data) {
      GeneralService.edit(`/b2b-orders/employee/settings`, {
        [data.name]: data.value,
      })
        .then((data) => {
          this.$toast.success(data.data.message);
        })
        .catch((e) => {
          this.$toast.error("Неизвестная ошибка при изменении настроек", {
            duration: 5000,
          });
        });
    },
    /// ОБРАБОТЧИК ПЕРЕХОДА ПО ВКЛАДКАМ
    async handleTabChange(newTab, oldTab) {
      if (newTab !== oldTab) {
        this.activateTab = newTab;
        await this.resetFilter();
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    onAcceptDelete() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(`/b2b-orders/${this.activeSelectRowsMultiple}`)
          .then((data) => {
            this.$toast.success(data.data.message);
          })
          .catch((e) => {
            this.activeSelectRowsMultiple = [];
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.$modal.hide("deleteModal");
            this.loadData();
          });
      }
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    updateFilterItem(field, operator, value) {
      const idx = this.filter.findIndex(
        (x) => x.field === field && (operator ? x.operator === operator : true)
      );

      if (!value) {
        if (idx >= 0) this.filter.splice(idx, 1);
        return;
      }

      const entry = { field, value, ...(operator && { operator }) };
      if (idx >= 0) {
        this.filter.splice(idx, 1, entry);
      } else {
        this.filter.push(entry);
      }
    },

    setCreatedAtFilter(direction, date) {
      const isoDate = date ? date.split(".").reverse().join("-") : "";
      if (direction === "from") {
        this.updateFilterItem(
          "b2b_orders__created_at",
          ">=",
          isoDate ? `${isoDate} 00:00:00` : ""
        );
      } else if (direction === "to") {
        this.updateFilterItem(
          "b2b_orders__created_at",
          "<=",
          isoDate ? `${isoDate} 23:59:59` : ""
        );
      }
    },

    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.$refs.topFilter
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });

      this.filterTimes.ordersCreateStart = [];
      this.filterTimes.ordersCreateEnd = [];
      this.selectsFilter = {
        b2b_orders__status_id: [],
        b2b_orders__b2b_product_id: [],
        b2b_orders__city_id: [],
      };
      this.filter = [];
      this.loadData();
    },

    onCloseModal() {
      this.currentId = null;
      this.activeSelectRowsMultiple = [];
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/b2b-orders/employee/settings`)
          .then((data) => {
            this.userPageSetting = Object.assign(
              this.userPageSetting,
              data.data.data
            );
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке настроек", {
              duration: 5000,
            });
          }),
        GeneralService.get(`/b2b-orders/select/cities`)
          .then((data) => {
            this.selectsDataForCreateModal.b2b_orders__city_id = data.data.data;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке городов", {
              duration: 5000,
            });
          }),
        GeneralService.get(`/b2b-orders/select/companies`)
          .then((data) => {
            this.selectsDataForCreateModal.b2b_orders__buyer_company_id =
              data.data.data.map((val) => {
                return {
                  label: Object.entries(val)[0][1],
                  value: Object.entries(val)[0][0],
                };
              });
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке компаний", {
              duration: 5000,
            });
          }),
        GeneralService.get(`/b2b-orders/select/products`)
          .then((data) => {
            this.selectsDataForCreateModal.b2b_orders__b2b_product_id =
              data.data.data;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке продуктов", {
              duration: 5000,
            });
          }),

        //     selectsDataForCreateModal: {
        //   "b2b_orders__b2b_product_id": [],
        //   "b2b_orders__buyer_company_id": [],
        //   "b2b_orders__city_id": []
        // },

        //
        // /finreestr-funds?where=[{"field":"finreestr_funds__is_coming","value":1}]&fields=finreestr_funds__id,finreestr_funds__name,finreestr_funds__is_coming
      ]).then(() => {
        GeneralService.get(
          `/b2b-orders/table/${
            this.activateTab == "Активные" ? "active" : "archive"
          }`,
          {
            params: {
              ...this.paginationFinesStateParams,
              page: page,
              limit: this.limitPaginationValue,
              where: JSON.stringify([...this.filter]),
            },
          }
        )
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.haveNewOrder = data.data.is_sound;
            this.selectsData = {
              b2b_orders__status_id: this.mapFiltersToOptions(
                data.data.filters.statuses
              ),
              b2b_orders__b2b_product_id: this.mapFiltersToOptions(
                data.data.filters.products
              ),
              b2b_orders__city_id: this.mapFiltersToOptions(
                data.data.filters.cities
              ),
            };

            this.getFinesAll(data.data.data);
            this.localLoading = false;
          })
          .catch((e) => {
            console.log(e);
            this.localLoading = false;
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    mapFiltersToOptions(raw) {
      if (!raw || typeof raw !== "object") return [];
      return Object.entries(raw).map(([value, label]) => ({ label, value }));
    },

    soundClick() {
      var audio = new Audio(); // Создаём новый элемент Audio
      // audio.src = this.userSetting.order_sound // Указываем путь к звуку "клика"
      audio.src = this.userSetting.soundFileOrderB2B; // Указываем путь к звуку "клика"
      audio.play(); // Автоматически запускаем
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    this.loadData();
    this.intervalUpdate = setInterval(async () => {
      await this.loadData();
      if (this.userPageSetting.sound && this.haveNewOrder) {
        this.soundClick();
        this.haveNewOrder = false;
      }
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.intervalUpdate);
  },
  created() {
    this.activateTab = "Активные";
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),

    computedTabParams() {
      switch (this.activateTab) {
        case this.dataLang["register_object_owners_text_3"]:
          return {
            url: "fiz",
          };
        case this.dataLang["register_object_owners_text_4"]:
          return {
            url: "ip",
          };
        case this.dataLang["register_object_owners_text_5"]:
          return {
            url: "ur",
          };
      }
    },

    // columnsPromo

    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "1%",
          align: "center",
        },
        {
          title: "Заявка",
          children: [
            {
              field: "b2b_orders__id",
              key: "1622336",
              title: "№",
              align: "center",
              width: "4%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"b2b_orders__id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: "b2b_orders__created_at",
              key: "5334543",
              title: "Дата/ Время UTC",
              align: "center",
              width: "8%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                    <div style={"height: 20px"}></div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span
                    title={
                      row.b2b_orders__created_at
                        ? this.$time(row.b2b_orders__created_at).format(
                            `${this.userSetting.company__tempalte_date} ${this.userSetting.company__tempalte_time}`
                          )
                        : ""
                    }
                  >
                    {row.b2b_orders__created_at
                      ? this.$time(row.b2b_orders__created_at).format(
                          `${this.userSetting.company__tempalte_date} ${this.userSetting.company__tempalte_time}`
                        )
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "cities__name",
              key: "6234331",
              title: "Город",
              align: "center",
              width: "6%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseSelect
                      vModel={this.selectsFilter.b2b_orders__city_id}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) => x.field == "b2b_orders__city_id"
                          )
                        ) {
                          this.filter.push({
                            field: "b2b_orders__city_id",
                            value: e.value,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "b2b_orders__city_id"
                            )
                          ].value = e.value;
                        }
                      }}
                      style={"width: 100%"}
                      label={"label"}
                      placeholder={""}
                      id={"id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.b2b_orders__city_id}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "product_name",
              key: "125441",
              title: "Продукт/ услуга",
              align: "center",
              width: "10%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                    <div style={"height: 20px"}></div>
                  </div>
                );
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseSelect
                      vModel={this.selectsFilter.b2b_orders__b2b_product_id}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) => x.field == "b2b_orders__b2b_product_id"
                          )
                        ) {
                          this.filter.push({
                            field: "b2b_orders__b2b_product_id",
                            value: e.value,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "b2b_orders__b2b_product_id"
                            )
                          ].value = e.value;
                        }
                      }}
                      style={"width: 100%"}
                      label={"label"}
                      placeholder={""}
                      id={"id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.b2b_orders__b2b_product_id}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "b2b_orders__finance_proceeds",
              key: "13661",
              title: "Сумма",
              align: "center",
              width: "5%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.b2b_orders__finance_proceeds
                      ? row.b2b_orders__finance_proceeds.replace(".", ",")
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "b2b_orders__supplier_amount",
              key: "999065",
              title: "Комиссия Сириус",
              align: "center",
              width: "5%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.b2b_orders__supplier_amount
                      ? row.b2b_orders__supplier_amount.replace(".", ",")
                      : ""}
                  </span>
                );
              },
            },
          ],
        },

        {
          title: "Покупатель",
          children: [
            {
              field: "b2b_orders__buyer_company_id",
              key: "456845",
              title: "SID",
              align: "center",
              width: "4%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{}}
                      inputName={"b2b_orders__buyer_company_id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: "employees__name",
              key: "99943",
              title: "ФИО",
              align: "center",
              width: "15%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
            },
            {
              field: "employees__phone",
              key: "868686",
              title: "Телефон",
              align: "center",
              width: "8%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
            },
          ],
        },
        {
          field: "b2b_orders__supplier_company_id",
          key: "986724",
          title: "SID пост",
          align: "center",
          width: "6%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "comment",
          key: "534534543",
          title: "Последний комментарий",
          align: "center",
          width: "12%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "status",
          key: "62341",
          title: "Статус",
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div style={"height: 20px"}></div>
                <div class={"text-center"}>{column.title}</div>

                <BaseSelect
                  vModel={this.selectsFilter.b2b_orders__status_id}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find(
                        (x) => x.field == "b2b_orders__status_id"
                      )
                    ) {
                      this.filter.push({
                        field: "b2b_orders__status_id",
                        value: e.value,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "b2b_orders__status_id"
                        )
                      ].value = e.value;
                    }
                  }}
                  style={"width: 100%"}
                  label={"label"}
                  placeholder={""}
                  id={"id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.b2b_orders__status_id}
                ></BaseSelect>
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
